
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.5.667h7A4.837 4.837 0 0117.334 5.5v7a4.837 4.837 0 01-4.834 4.833h-7A4.837 4.837 0 01.667 12.5v-7A4.837 4.837 0 015.5.667zm-.166 1.666c-1.659 0-3 1.342-3 3v7.333c0 1.659 1.341 3 3 3h7.333c1.658 0 3-1.341 3-3V5.333c0-1.658-1.342-3-3-3H5.334zm8.041 1.25a1.042 1.042 0 110 2.084 1.042 1.042 0 010-2.084zM9 4.833c2.3 0 4.167 1.867 4.167 4.167S11.3 13.166 9 13.166A4.168 4.168 0 014.834 9C4.834 6.7 6.7 4.833 9 4.833zM9 6.5A2.497 2.497 0 006.5 9c0 1.383 1.117 2.5 2.5 2.5 1.384 0 2.5-1.117 2.5-2.5S10.384 6.5 9 6.5z","fill":"#F20C7B"}})])
          )
        }
      }
    